var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutubeForm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 18,
    viewBox: "0 0 26 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0994 1.75369C23.4413 0.561823 22.7272 0.342593 21.273 0.259224C19.8204 0.158872 16.1676 0.117188 13.0031 0.117188C9.8325 0.117188 6.17821 0.158872 4.72711 0.25768C3.276 0.342593 2.56031 0.560279 1.89617 1.75369C1.21838 2.94402 0.869629 4.99428 0.869629 8.60386C0.869629 8.60695 0.869629 8.60849 0.869629 8.60849C0.869629 8.61158 0.869629 8.61312 0.869629 8.61312V8.61621C0.869629 12.2103 1.21838 14.2761 1.89617 15.454C2.56031 16.6459 3.27449 16.862 4.72559 16.9624C6.17821 17.0488 9.8325 17.0998 13.0031 17.0998C16.1676 17.0998 19.8204 17.0488 21.2745 16.9639C22.7287 16.8636 23.4429 16.6474 24.1009 15.4556C24.7848 14.2776 25.1305 12.2119 25.1305 8.61775C25.1305 8.61775 25.1305 8.61312 25.1305 8.61004C25.1305 8.61004 25.1305 8.60695 25.1305 8.6054C25.1305 4.99428 24.7848 2.94402 24.0994 1.75369Z",
    fill: "#E93F3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.76514 13.8645V4.16016L17.0434 9.01233L9.76514 13.8645Z",
    fill: "#FAFAFA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeForm);
export default __webpack_public_path__ + "static/media/youtube-form.cef6c37e5ff7a9d0214383b6c13431a8.svg";
export { ForwardRef as ReactComponent };